import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep'

class Pemasukan extends BaseService {
	async getPemasukanByCompany(opts = {}) {
		this.endPoint = '/get-all-submission';
		return this.get(opts);
  }
	async getPemasukanByType(type,opts = {}) {
    this.endPoint = '/get-submission-accountant-type?type='+type;
		return this.get(opts);
  }
	async getPemasukanCompanyByCategoryId(page,opts = {}) {
		this.endPoint = '/get-submission-category-company?category_id='+page.category_id +'&jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getPemasukanUserByCategoryId(page,opts = {}) {
    this.endPoint = '/get-submission-category?category_id='+page.category_id +'&jum='+ page.jum+ '&page='+ page.page;
		return this.get(opts);
  }
	async getPemasukanByUser(opts = {}) {
		this.endPoint = '/get-submission-user';
		return this.get(opts);
  }
  async getPemasukanByIdPOS(id,opts = {}) {
		this.endPoint = '/submission-pos/'+id;
		return this.get(opts);
  }
	async getPemasukanById(id,opts = {}) {
		this.endPoint = '/submission/' + id;
		return this.get(opts);
  }
  async createPemasukan(payload){
    this.endPoint = '/submission';
    return await this.post(payload); 
  }
  async editDueDate(payload){
    this.endPoint = '/editDueDate';
    return await this.post(payload); 
  }
  
  async createBulk(payload){
    this.endPoint = '/submissions/fulfilled_submission'
    return await this.post(payload)
  }
  async updatePemasukan(id,payload,opts={}){
    this.endPoint = '/submission';
    return await this.putOne(id,payload,opts);
  }
  async updateStatusPemasukan(id,payload,opts={}){
    this.endPoint = '/update-status-submission';
    return await this.putOne(id,payload,opts);
  }
  async deletePemasukan(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
  async filterPemasukan(payload) {
    this.endPoint = '/submissions.filter';
    return await this.post(payload);
  }
  async getAttachmentSubmission(id,opts = {}) {
    this.endPoint = '/getAttachmentSubmission/'+id;
		return this.get(opts);
  }
  async createSubmissionAttachment(payload, opts = {}) {
		this.endPoint = '/uploadAttachmentSubmission'
		const newOpts = cloneDeep(opts, {
		  headers: {
			'Content-Type': 'multipart/form-data'
		  }
		})
	
		return this.post(payload.data, newOpts)
  }
  async removeAttachmentSubmission(id,opts={}) {
		this.endPoint = 'deleteAttachmentSubmission';
		return await this.delete(id,opts={});
  }
  async deleteRead(payload){
    this.endPoint = '/delete-read';
    return await this.post(payload); 
  }
  async createRead(payload){
    this.endPoint = '/store-read';
    return await this.post(payload); 
  }
  // async deletePerson(payload){
  //   this.endPoint = '/person-delete';
  //   return await this.post(payload); 
  // }
}

export default new Pemasukan();